module.exports = __webpack_public_path__ + "media/fonts/UHC_Sans/UHCSans-Medium-99cf6dc5fd9d60f57f87f269c91e7d6c.woff";